<template>
    <div class="admin-brand-settings-form container">
        <div class="row py-5">
            <div class="col-12">
                <h1 class="pstitle">
                    <a href="/admin/cms">Admin CMS</a>
                    <span> - </span>
                    <a href="/admin/cms/brands">Brands</a>
                </h1>
            </div>
            <div class="col-12">
                <i><strong>Note:</strong> Any and all changes take effect immediately upon saving below.</i>
            </div>
        </div>

        <div class="col-sm-12 text-end form-options">
            <a href="javascript:void(0)" class="pt-1 cursor" :onclick="handleRevertBrandOptions" aria-label="Revert Brand Settings">Revert</a>
        </div>

        <div v-for="(brand, index) in brandConfig"
             :key="index"
             class="brand-section">
            <h2 class="pstitle brand-title">{{ brand.brandName || "Untitled Brand" }}</h2>

            <div class="row py-3">
                <!-- Brand Name -->
                <div class="col-xs-12 col-md-4">
                    <input type="text" class="form-control"
                            disabled
                           :id="'brandName-' + index"
                           placeholder="Brand name"
                           v-model="brand.brandName" />
                    <label :for="'brandName-' + index" class="form-label">Brand Name</label>
                </div>
                <!-- Brand Logo svg -->
                <div class="col-xs-12 col-md-4">
                    <input type="text" class="form-control"
                           :id="'brandLogo-' + index"
                           placeholder="Brand/logo.svg"
                           v-model="brand.brandLogo" 
                           disabled
                           />
                    <label :for="'brandLogo-' + index" class="form-label">Brand Logo</label>
                </div>
                <!-- Brand Footer svg -->
                <div class="col-xs-12 col-md-4">
                    <input type="text" class="form-control"
                           :id="'footerLogo-' + index"
                           placeholder="Brand/footer-logo.svg"
                           v-model="brand.footerLogo" 
                           disabled
                           />
                    <label :for="'footerLogo-' + index" class="form-label">Footer Logo</label>
                </div>
            </div>

            <div class="row py-3">
                <!-- Link - Main Brand -->
                <div class="col-xs-12 col-md-4">
                    <input type="text" class="form-control"
                           :id="'brandLink-' + index"
                           placeholder="Brand link"
                           v-model="brand.brandLink" />
                    <label :for="'brandLink-' + index" class="form-label">Brand Link</label>
                </div>
                <!-- Link - Design a Boat -->
                <div class="col-xs-12 col-md-4">
                    <input type="text" class="form-control"
                           :id="'designBoatLink-' + index"
                           placeholder="Design a Boat link"
                           v-model="brand.links.sales.design_a_boat.link" />
                    <label :for="'designBoatLink-' + index" class="form-label">Design a Boat Link</label>
                </div>
                <!-- Link - Apparel -->
                <div class="col-xs-12 col-md-4">
                    <input type="text" class="form-control"
                           :id="'apparelLink-' + index"
                           placeholder="Apparel link"
                           v-model="brand.links.company.apparel.link" />
                    <label :for="'apparelLink-' + index" class="form-label">Apparel Link</label>
                </div>
            </div>

            <div class="row py-3">
                <!-- Link - Terms & Conditions -->
                <div class="col-xs-12 col-md-4">
                    <input type="text" class="form-control"
                           :id="'termsConditionsLink-' + index"
                           placeholder="Terms & Conditions link"
                           v-model="brand.links.legal.terms_and_conditions.link" />
                    <label :for="'termsConditionsLink-' + index" class="form-label">Terms & Conditions Link</label>
                </div>
                <!-- Link - Privacy Policy -->
                <div class="col-xs-12 col-md-4">
                    <input type="text" class="form-control"
                           :id="'privacyPolicyLink-' + index"
                           placeholder="Privacy Policy link"
                           v-model="brand.links.legal.privacy_policy.link" />
                    <label :for="'privacyPolicyLink-' + index" class="form-label">Privacy Policy Link</label>
                </div>
                <!-- Link - Accessibility -->
                <div class="col-xs-12 col-md-4">
                    <input type="text" class="form-control"
                           :id="'accessibilityLink-' + index"
                           placeholder="Accessibility link"
                           v-model="brand.links.legal.accessibility.link" />
                    <label :for="'accessibilityLink-' + index" class="form-label">Accessibility Link</label>
                </div>
            </div>

            <div class="row py-3">
                <!-- Link - Facebook -->
                <div class="col-xs-12 col-md-4">
                    <input type="text" class="form-control"
                           :id="'facebookLink-' + index"
                           placeholder="Facebook link"
                           v-model="brand.links.social_media.facebook.link" />
                    <label :for="'facebookLink-' + index" class="form-label">Facebook Link</label>
                </div>
                <!-- Link - Instagram -->
                <div class="col-xs-12 col-md-4">
                    <input type="text" class="form-control"
                           :id="'instagramLink-' + index"
                           placeholder="Instagram link"
                           v-model="brand.links.social_media.instagram.link" />
                    <label :for="'instagramLink-' + index" class="form-label">Instagram Link</label>
                </div>
                <!-- Link - Youtube -->
                <div class="col-xs-12 col-md-4">
                    <input type="text" class="form-control"
                           :id="'youtubeLink-' + index"
                           placeholder="Youtube link"
                           v-model="brand.links.social_media.youtube.link" />
                    <label :for="'youtubeLink-' + index" class="form-label">Youtube Link</label>
                </div>
            </div>
        </div>

        <div class="flex justify-content-end">
            <span class="me-3 pt-2">{{ saveMessage }}</span>
            <custom-button class="btn-main"
                    v-on:btnClicked="showConfirmSave = true">
                Save All Brand Settings
            </custom-button>
        </div>

        <modal-card v-model="showConfirmSave"
                    title="Confirm Save"
                    size="sm"
        >
        <p class="text-black text-lg">Are you sure you want to save all brand settings as they are currently configured?</p>
        <p class="text-black text-lg">This updates the site for every brand on the next page load.</p>
        <template #footer="{ close }">
                <custom-button class="btn-main" v-on:btnClicked="close">
                    Cancel
                </custom-button>
                <custom-button class="btn-main" v-on:btnClicked="handleConfirm">
                    Save
                </custom-button>
            </template>      
        </modal-card>

    </div>
</template>

<script>
import CustomButton from "../../components/atoms/CustomButton.vue";
import ModalCard from "../../components/atoms/ModalCard.vue";
import siteConfig from "../../constants/runtime-config";

// Every nested path the form binds to with v-model
const LINK_PATHS = [
    ["links", "brand"],
    ["links", "sales", "design_a_boat"],
    ["links", "company", "apparel"],
    ["links", "legal", "terms_and_conditions"],
    ["links", "legal", "privacy_policy"],
    ["links", "legal", "accessibility"],
    ["links", "social_media", "facebook"],
    ["links", "social_media", "instagram"],
    ["links", "social_media", "youtube"],
];

// Creates any missing objects along a path so v-model never hits undefined
function ensurePath(obj, path) {
    let current = obj;
    for (const key of path) {
        if (current[key] == null || typeof current[key] !== "object") {
            current[key] = {};
        }
        current = current[key];
    }
}

function loadBrands() {
    // Deep copy so typing in the form doesn't change the live config other components read
    const raw = JSON.parse(JSON.stringify(siteConfig["brand-config"] || []));
    return raw.map((item) => {
        const brand = item.brand || {};
        LINK_PATHS.forEach((path) => ensurePath(brand, path));
        return brand;
    });
}

export default {
    name: "BrandsCmsPage",
    components: {
        CustomButton,
        ModalCard,
    },
    data() {
        const brands = loadBrands();
        return {
            brandConfig: brands,
            originalBrandConfig: JSON.parse(JSON.stringify(brands)),
            saveMessage: "",
            showConfirmSave: false,
        };
    },
    methods: {
        handleRevertBrandOptions() {
            this.brandConfig = JSON.parse(JSON.stringify(this.originalBrandConfig));
        },

        saveSubmit() {
            const payload = {
                "brand-config": this.brandConfig.map((brand) => ({ brand })),
            };

            this.saveMessage = "Saving...";
            this.axios.post("/admin/site-config", payload)
                .then(() => {
                    // Revert now goes back to what was just saved
                    this.originalBrandConfig = JSON.parse(JSON.stringify(this.brandConfig));
                    this.saveMessage = "Saved.";
                })
                .catch((err) => {
                    this.saveMessage = "Save failed (" + (err.response?.status ?? "network error") + ").";
                    console.log(err);
                });
        },

        handleConfirm() {
            this.showConfirmSave = false;
            this.saveSubmit();
        }
    },
};
</script>

<style lang="scss">
.admin-brand-settings-form {
    .form-control {
        appearance: auto;
    }

    .row {
        row-gap: 1rem;
    }

    .row .form-control + .form-label {
        top: -45px;
    }

    .form-options {
        display: flex;
        justify-content: flex-end;
        gap: 1rem;
    }

    .brand-section {
        padding: 2rem 0;
        border-bottom: 1px solid #ddd;

        &:last-child {
            border-bottom: none;
        }
    }

    .brand-title {
        margin-bottom: 1.5rem;
    }
}
</style>